"use strict";

//refpro
(function () {
    var rp = document.createElement('script');
    rp.type = 'text/javascript';
    rp.async = true;
    rp.src = '//www.dukascopy.com/refpro/refpro.js?0.05';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(rp, s);
})();
//End refpro

var $body = jQuery('body'),
    $document = jQuery(document),
    $window = jQuery(window),
    cssBreakPoints = {
	    'xs': 480,
	    'sm': 768,
	    'md': 992,
	    'lg': 1250
    },
    transitionDuration = 200;


var chatloaded = false;

function onDCCReady() {
    $('.btn-chat').removeClass('loading');
//    $('#dc-support-chat-btn').addClass('chat-opened');
    $('.btn-chat').fadeOut(.2);
    DCC_loadChat();
    chatloaded = true;
}

function onDCC_ChatClosed() {

    // $('#dc-support-chat-btn').removeClass('chat-opened').removeClass('loading');
    $('.btn-chat').fadeIn(.2);

    $('.btn-chat').on('click', function(){
        DCC_openChat();
        $('.btn-chat').fadeOut(.2);
    });

}


function hideOneShowOther(willBeHidden, willBeShown, callback) {
    var willBeShownBlockHeight = willBeShown.css({'visibility':'hidden', 'display':'block'}).height();
    willBeShown.css({'display':'none', 'visibility':'visible'});
    // var willBeShownBlockHeight = willBeShown.height();
    var willBeHiddenBlockHeight = willBeHidden.height() || 0,
        minHeightedBlock = willBeShown.parent();

    if (willBeShownBlockHeight > willBeHiddenBlockHeight) {
        // console.log('>',willBeShownBlockHeight)
        minHeightedBlock.css('min-height', minHeightedBlock.outerHeight());
        willBeHidden.fadeOut(transitionDuration, function() {
            willBeHidden.removeClass('active');
            willBeShown.addClass('slideDownFadeIn active').slideDownFadeIn(transitionDuration, function() {
                // willBeShown.addClass('shown');
                setTimeout(function() {
                    willBeShown.removeClass('slideDownFadeIn shown');
                    minHeightedBlock.css('min-height', 'auto');//in case of wrong calculations
                }, transitionDuration);

                if (callback) {
                    callback();
                }
            });
        });
    } else if (willBeShownBlockHeight < willBeHiddenBlockHeight) {
        // console.log('<',willBeShownBlockHeight)
        minHeightedBlock.css('min-height', minHeightedBlock.outerHeight() - minHeightedBlock.height() + willBeShownBlockHeight);
        willBeHidden.addClass('slideDownFadeIn shown').fadeOutSlideUp(transitionDuration, function() {
            willBeHidden.removeClass('active slideDownFadeIn');
            willBeShown.fadeTo(transitionDuration, 1, function() {//fadeTo instead of fadeIn, because of Safary's blinking =/
                willBeShown.addClass('active').css('opacity', '');//opacity, '' - because of fadeTo
                minHeightedBlock.css('min-height', 'auto');//in case of wrong calculations

                if (callback) {
                    callback();
                }
            });
        });
    } else {
        // console.log('=')
        minHeightedBlock.css('min-height', minHeightedBlock.outerHeight());
        willBeHidden.fadeOut(transitionDuration, function() {
            willBeHidden.removeClass('active');
            willBeShown.fadeTo(transitionDuration, 1, function() {//fadeTo instead of fadeIn, because of Safary's blinking =/
                // willBeShown.addClass('shown');
                willBeShown.addClass('active').css('opacity', '');//opacity, '' - because of fadeTo
                // willBeShown.removeClass('slideDownFadeIn shown');
                if (callback) {
                    callback();
                }
            });
        });
    }
    
    // minHeightedBlock.css('min-height', minHeightedBlock.outerHeight() - minHeightedBlock.height() + willBeShownBlockHeight);
    // willBeHidden.fadeOutSlideUp(transitionDuration, function() {
    // 	willBeShown.fadeIn(transitionDuration, function() {
    // 		if (callback) {
    // 			callback();
    // 		}
    // 	});
    // });
}

jQuery.fn.extend({
    slideDownFadeIn: function(dur, callback) {
		var self = this;
		self.addClass('slideDownFadeIn');

		self.slideDown(dur, function() {
			self.addClass('shown');
			setTimeout(function() {
				self.removeClass('slideDownFadeIn shown');
				if (callback) {
					callback.call(self);
				}
			}, dur);
		});
		
		return self;
	},
	fadeOutSlideUp: function(dur, callback) {
		var self = this;
		self.addClass('shown fadeOutSlideUp');
		self.removeClass('shown');
		setTimeout(function() {
			self.slideUp(dur, function() {
				self.removeClass('fadeOutSlideUp');
				if (callback) {
					callback.call(self);
				}
			});
        }, dur);
        
		return self;
    }
});

function setCookie(name, value, expires, path, domain, secure) {
    document.cookie =
        name +
        "=" +
        escape(value) +
        (expires ? "; expires=" + new Date(expires) : "") +
        (path ? "; path=" + path : "") +
        (domain ? "; domain=" + domain : "") +
        (secure ? "; secure" : "");
}

(function($) {
    $(function(){
        $('.btn-inactive').click(function(e) {
            e.preventDefault ? e.preventDefault() : e.returnValue = false;
        });

        //Home
        //Main slider
        if ($body.hasClass('home')) {
            var animBlock = $('#change-bckg');
            var classList = ['bg-1', 'bg-2', 'bg-3', 'bg-4', 'bg-5', 'bg-6', 'bg-7', 'bg-8', 'bg-9', 'bg-10'];
            var currClass = 0;
            var nextClass = 1;
            setInterval(changeClass, 5000);
            function changeClass() {
                animBlock.removeClass(classList[currClass]).addClass(classList[nextClass]);
                currClass = nextClass;
                nextClass = currClass + 1;
                if (nextClass > classList.length - 1) {
                    nextClass = 0;
                }
            }
        }

        //For inputs with animated label
        $('.with-label').each(function() { //If case some info after refresh
            var $this = $(this);
            if ($this.val()) {
                $this.parent().addClass('entered');
            }
        });
        $('.with-label').on('blur', function() {
            var $this = $(this);
            if ($this.val()) {
                $this.parent().addClass('entered');
            } else {
                $this.parent().removeClass('entered');
            }
        });

        //Binaries
        //Binary game
        if ($body.hasClass('binaries')) {
            var widget = new dc.BinaryOptionWidget(),
                chartBtns = $('.chart-button'),
                amountSelect = $('#amount'),
                circleLoader = $('.circle-loader');
            widget.render(document.getElementById('chart-container'));
            widget.init(function() {
                var offset = Date.now() - widget.chart_.getDataProvider().peek().getTime();
                chartBtns.click(function() {
                    var $this = $(this),
                        bet = $this.attr('id');
                    if ($this.hasClass('disabled')) {
                        return false;
                    } else {
                        var amount = amountSelect.val();
                        chartBtns.addClass('disabled');
                        if (bet === 'call') {
                            $('.amount-block,#put').hide();
                            circleLoader.addClass('animated call').show();
                            widget.startOption(dc.BinaryOptionWidget.Direction.CALL, function(success) {
                                checkResult(success, $('.put-block'));
                            }, offset, 60000);
                        } else if (bet === 'put') {
                            $('.amount-block,#call').hide();
                            circleLoader.addClass('animated put').show();
                            widget.startOption(dc.BinaryOptionWidget.Direction.PUT, function(success) {
                                checkResult(success, $('.call-block'));
                            }, offset, 60000);
                        }
                    }

                    function checkResult(success, blockToPut) {
                        if (success) {
                            $('#chart-result_suc').appendTo(blockToPut).find('.money').text('$' + amount + ' + $' + amount * 0.9);
                        } else {
                            $('#chart-result_fail').appendTo(blockToPut);
                        }
                       
                       circleLoader.removeClass('animated call put').addClass('restart').click(chartRestart);
                    }

                });

                function chartRestart() {
                    circleLoader.off('click');
                    $('#chart-result_suc,#chart-result_fail').appendTo('#results-container');
                    chartBtns.removeClass('disabled');
                    circleLoader.removeClass('restart').hide();
                    $('.amount-block,#put,#call').show();
                }
            });
        }

    	$('.btn-chat').on('click', function() {

            var $this = $(this);
            if (chatloaded === false) {
                var scrpt = document.createElement('script');
                scrpt.setAttribute('src', 'https://chat.dukascopy.com/dccloader.js');
                scrpt.setAttribute('payer-auth-token', "");
                scrpt.setAttribute('entry-point-id', (branch == 'europe') ? '56' : '30'); // 30 - swiss	// 56 - europe	// 76 - japan
                scrpt.setAttribute('right-offset', "30");
                scrpt.setAttribute('bottom-offset', "30");
                scrpt.setAttribute('title', "Chat with us");
                scrpt.setAttribute('prompt-message', "Type your message");
                scrpt.setAttribute('remove-start-button', "true");

                $this.addClass('loading');
                document.body.appendChild(scrpt);
                chatloaded = true;
            } else {
                DCC_openChat();
                console.log('state 2');
                $('.btn-chat').fadeOut(.2);
            }

            // var $this = $(this);
            // $this.addClass('loading');
            // $.getJSON(root_path + 'loc/'+lang+'.txt', function(json) {
            //     var chat_welcome = json['Forex']['forex_land_chat_welcome'] ? json['Forex']['forex_land_chat_welcome'] : 'Have a question?',
            //         chat_text = json['Forex']['forex_land_chat_text'] ? json['Forex']['forex_land_chat_text'] : 'Leave your message';
            //     var chatScript = document.createElement('script');
            //     chatScript.src = 'https://support.dukascopy.com/loader.js';
            //     $(chatScript).attr({
            //         'supportChatDelay': '0',
            //         'supportChatCollapsed': 'false',
            //         'supportChatWelcome': chat_welcome,
            //         'supportChatInputText': chat_text,
            //         'async': 'true',
            //         'lang': lang,
            //         'data': 'D7WBWOWdDAWRW3WBDQWlDQDAWhDADQDTDpIYDzWvDXWcDADNIEIuIcWiDCWTDWWSWKWDDLDYW6WKWdWiIcWRIEWhWdD8IEWfIEWlDWWEIcDf',
            //         'supportChatEp': (branch == 'europe') ? '56' : ''
            //     })
            //     var waitChat = window.setInterval(function(){ //Т. к. нет нормального коллбэка
            //         if($('.dccContainerChat').html()){
            //            clearInterval(waitChat);
            //            $this.addClass('hidden');
            //            document.dcc_openSupportChat(); // Волшебный пинок для открытитя чата.
            //            setCookie('dcChatActive', '1', {
            //                 expires: 3600,
            //                 path: '/'
            //            });
            //         }
            //     },100);
            //     document.body.appendChild(chatScript);
            //     $this.off('click');
            // });
        });
    	
        var htmlBody =  $('html, body');
    	$('.inner-link').click(function(e) {
            e.preventDefault ? e.preventDefault() : e.returnValue = false;
            var sectionDirection = $(this).attr('href');
           htmlBody.animate({scrollTop:$(sectionDirection).offset().top-$('header').height() - 30}, 'slow');
        });

        //Tablet-menu
        var tabMenu = $('#tablet-menu'),
            tabMenuButt = $('#tablet-menu-btn');
        tabMenuButt.on('click', function() {
            tabMenuButt.toggleClass('active');
            tabMenu.toggleClass('opened');
            $document.on('click.tab-menu', function(e) {
                if ((!$(e.target).is(tabMenu.find('*'))) && (!$(e.target).is(tabMenuButt)) && (!$(e.target).is(tabMenuButt.find('*')))) {
                    tabMenu.removeClass('opened');
                    tabMenuButt.removeClass('active');
                    $document.off('click.tab-menu');
                }
            })
        });

        //Mob menu
        var mobMenu = $('#mob-menu'),
            mobMenuButt = $('#mob-menu-btn');
        mobMenuButt.on('click', function() {
            mobMenuButt.toggleClass('active');
            mobMenu.toggleClass('opened');
            $document.on('click.mob-menu', function(e) {
                if ((!$(e.target).is(mobMenu.find('*'))) && (!$(e.target).is(mobMenuButt)) && (!$(e.target).is(mobMenuButt.find('*')))) {
                    mobMenu.removeClass('opened');
                    mobMenuButt.removeClass('active');
                    $document.off('click.mob-menu');
                }
            })
        });

        //For links on JForex/platforms pages
        var installJforexLink = $('#install-jforex3');
        if (installJforexLink.length) {
            var jfLinksToOs = {
                win32: 'JForex_windows.exe',
                win64: 'JForex_windows-x64.exe',
                macOS: 'JForex_macos.dmg',
                linux32: 'JForex_unix_32_JRE_bundled.sh',
                linux64: 'JForex_unix_64_JRE_bundled.sh'
            }
            var osys = detectOs(),
                commPart;
            if (branch == 'eu') {
                commPart = 'http://dukascopy-eu.cdn.online-trading-solutions.com/installer/dukascopy-eu/';
            } else {
                commPart = 'https://platform.dukascopy.com/jforex-installer/';
            }
            installJforexLink.attr('href', commPart + jfLinksToOs[osys])
        }
        //OS detection
        function detectOs() {
            var osys = 'win32';
            if (navigator.appVersion.indexOf("Win")>-1) {
                if (navigator.userAgent.indexOf('WOW64')>-1 || window.navigator.platform=='Win64'  ||  navigator.userAgent.indexOf('Win64')>-1) {
                    osys = 'win64';
                }
            } else if (navigator.appVersion.indexOf("Mac") > -1) {
                osys = 'macOS';
            } else if (navigator.appVersion.indexOf("X11") > -1 || navigator.appVersion.indexOf("Linux")>-1) {
                if (window.navigator.platform.indexOf("64") > -1) {
                    osys = 'linux64';
                } else {
                    osys = 'linux32';
                }
            }
            return osys;
        }

        //Comments slider
        var comm_responsive = {
            0: {
                items:1
            }
        };
        comm_responsive[cssBreakPoints.md] = {items:2};
        comm_responsive[cssBreakPoints.lg] = {items:3};
        $('.comments-slider').owlCarousel({
            //loop: true,
            rtl: rtl,
            nav: false,
            dots: true,
            autoplay: true,
            autoplayHoverPause: true,
            autoHeight: true,
            rewind: true,
            responsive: comm_responsive
        });

        //Styled selects
        $('select').chosen({
            disable_search_threshold: 15,
            width: 'auto',
            placeholder_text_single: '...'
        });
        $('.preview-select').remove();

        //VI and rates animations
        var canvas = document.getElementById('circle-15m'),
            ratesBlock = document.querySelectorAll('.comments')[0];

        function AnimatedBlock(startBlock, animateFn) {
            this.startBlock = startBlock;
            this.animateFn = animateFn;

            var self = this;

            function checkForAnimation() {
                if (self.startBlock.getBoundingClientRect().top + self.startBlock.offsetHeight / 2 < document.documentElement.clientHeight) {
                    self.animateFn();
                    document.removeEventListener('scroll', checkForAnimation);
                }
            }
            document.addEventListener('scroll', checkForAnimation);
        }
        if (canvas) {
            var circle = new AnimatedBlock(canvas, animateCircle.animate);
        }
        if (ratesBlock) {
            var rates = new AnimatedBlock(ratesBlock, animateRates.animate);
        }
    });
})(jQuery);